import {CookieManager} from "./cookie-consent/cookie-manager"

const COOKIE_CONSENT_COOKIE_NAME = 'cookieconsent_status'

window.WebCookieConsent = CookieManager.get(COOKIE_CONSENT_COOKIE_NAME)
